import VerticalModalList from "reusable-components/VerticalModalList";
import getNeedsModifiedScrollbars from "selectors/device/getNeedsModifiedScrollbars";
import { connect } from "react-redux";

function mapStateToProps(state, ownProps) {
  return {
    needsModifiedScrollbars: getNeedsModifiedScrollbars(state, ownProps),
    style: {
      height: state.viewport.dimensions.height,
    },
  };
}

export default connect(mapStateToProps)(VerticalModalList);
